module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg pause",
    class: {
      'c': _vm.showPause
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03298dce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pause/index.vue
// module id = 129
// module chunks = 1